import React from "react";
import { getMillisecondFromMinute } from "utils/common";
import Countdown from "react-countdown";

const CountdownWrapper: React.FC<{
  cdk: string;
  countDownCompleted(): void;
  time?: number;
}> = ({ cdk, countDownCompleted, time = 1.5 }) => {
  return (
    <Countdown
      key={`${cdk}`}
      date={React.useMemo(() => {
        return getMillisecondFromMinute(time);
        // eslint-disable-next-line react-hooks/exhaustive-deps
      }, [cdk])}
      renderer={({ minutes, seconds, completed }) => {
        if (completed) {
          countDownCompleted();
        }
        return (
          <span>
            {minutes < 10 ? `0${minutes}` : minutes}:
            {seconds < 10 ? `0${seconds}` : seconds}
          </span>
        );
      }}
    />
  );
};

export default CountdownWrapper;
